var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('landing-wrapper',{staticClass:"auth-page"},[_c('div',{staticClass:"auth-page__content-wrapper"},[_c('div',{staticClass:"auth-page__content-cont",class:{'auth-page__content-cont--android': _vm.isDownloadApkFile}},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }